import { useRef, useEffect } from 'react';
import { useGameStore } from '../store';
import { fmt } from '../utils/format';
import chongsanMp4 from '../../assets/chongsan.mp4';

export default function LiquidationScreen() {
  const show      = useGameStore((s) => s.showLiqScreen);
  const liqInfo   = useGameStore((s) => s.liqInfo);
  const retryGame = useGameStore((s) => s.retryGame);
  const videoRef  = useRef<HTMLVideoElement>(null);

  // 화면 열릴 때 비디오 재생
  useEffect(() => {
    if (show) videoRef.current?.play().catch(() => {});
    else      videoRef.current?.pause();
  }, [show]);

  if (!show) return null;

  return (
    <div id="liq-screen">
      <video
        ref={videoRef}
        id="liq-video"
        src={chongsanMp4}
        loop
        muted
        playsInline
      />
      <div id="liq-tint" />

      <div id="liq-scroll">
        <div id="liq-poem">
          살어리 살어리랏다<br />靑山에 살어리랏다
        </div>

        <div id="liq-badge">淸算</div>

        <div id="liq-details">
          {liqInfo ? (
            <>
              상단: {liqInfo.stockName}<br />
              차용배율: {liqInfo.levName} (×{liqInfo.lev})<br />
              총 손실: -{fmt(liqInfo.totalLoss)}냥
              {liqInfo.gapLoss > 0 && (
                <>
                  <br />
                  <span style={{ color: '#FF6B6B', fontSize: 12 }}>
                    ⚠ 갭 손실 -{fmt(liqInfo.gapLoss)}냥 (잔액 추가 차감)
                  </span>
                </>
              )}
            </>
          ) : '—'}
        </div>

        <button className="liq-btn" id="liq-retry" onClick={retryGame}>
          재기 도전
        </button>
      </div>
    </div>
  );
}
